import React from "react"
import Cabecalho from "../Cabecalho"
import { Loading } from "../RegistradorDePedidos"
import { AssinaturaEstabelecimentoForm } from "./components/AssinaturaEstabelecimentoForm"

export function Index() {
    return (
        <>
            <Cabecalho pagina="Assinatura" />
            <Loading />
            <AssinaturaEstabelecimentoForm />
        </>
    )
}
